export const ATTRIBUTE = 0
export const EVENT = 1
export const TEXT = 2
export const VALUE = 3

export default {
  ATTRIBUTE,
  EVENT,
  TEXT,
  VALUE
}